import axios from "axios";
import { sameOriginApi } from "@/lib/tenant";
import { readActiveStore, clearActiveStore } from "@/lib/activeStore";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = sameOriginApi ? `${window.location.origin}/api` : `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("s24_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const active = readActiveStore();                       // vendor's selected store; validated by the server
  if (token && active?.sid && !config.headers["X-Store-Id"]) config.headers["X-Store-Id"] = active.sid;
  return config;
});

// The server refused the selected store (removed / no longer ours): forget it and let the app fall back.
api.interceptors.response.use((r) => r, (err) => {
  const d = err.response?.data?.detail;
  if (err.response?.status === 403 && typeof d === "string" && d.includes("access to this store")) {
    clearActiveStore();
    window.dispatchEvent(new Event("store:revoked"));
  }
  return Promise.reject(err);
});

export function apiErr(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

/** Absolute URL for a file the API serves (e.g. "/api/uploads/x.png"); full URLs pass through. */
export const assetUrl = (path) => (!path || /^https?:\/\//i.test(path) ? path : `${BACKEND_URL}${path}`);

export default api;

export async function downloadFile(path, filename) {
  const token = localStorage.getItem("s24_token");
  const active = readActiveStore();
  const res = await fetch(`${API}${path}`, { headers: { Authorization: `Bearer ${token}`, ...(active?.sid ? { "X-Store-Id": active.sid } : {}) } });
  if (!res.ok) throw new Error("Download failed");
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}